"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTest = void 0;
const tslib_1 = require("tslib");
require("../../../../TdWebtoolkitControls/controls/Tree/Tree");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
let markup = require("./tree_tests.tmpl.htm");
// eslint-disable-next-line no-null/no-null
let notificationId = null;
const path1 = "48|157371|4/48|157372|4/48|157373|4/48|157374|4";
const path2 = "48|157371|4/48|157375|4/48|157376|4/48|157377|4";
const path3 = "48|157371|4/48|157375|4/48|157376|4/48|999999|4";
const path4 = "48|99999|4/48|11111|4/48|1|4/48|4242|4";
function Notify(msg) {
    if (notificationId)
        Utilities_1.synUtil.Notifications.remove(notificationId);
    notificationId = Utilities_1.synUtil.Notifications.info(msg);
}
function setPathAsync($tree, path) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const result = yield $tree.synTree("trySetPathAsync", path);
        Notify("Setting tree path, result: " + result);
    });
}
function createTree($tree) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        yield $tree
            .on("nodeSelected", (_evt, info) => {
            Notify("Node selected\n selectedId: " + info.selectedId + "\npath: " + info.path + "\nselectedParentId: " + info.selectedParentId);
        })
            .synTree({
            initialSelection: path2
        });
        Notify("Tree created");
    });
}
function renderTest() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let $contentPane = $("#testContentPane");
        $contentPane.html(markup);
        let $treeDiv = $contentPane.find(".treeDiv");
        let $tree = $contentPane.find(".treeControl");
        $treeDiv.kendoSplitter({
            orientation: "horizontal",
            panes: [{ size: "150px", }, {}]
        });
        yield createTree($tree);
        $treeDiv.find("button.destroyTreeButton")
            .on("click", () => {
            $tree.synTree("destroy");
        })
            .removeAttr("disabled");
        $treeDiv.find("button.recreateTreeButton")
            .on("click", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            $tree.synTree("destroy");
            yield createTree($tree);
        }))
            .removeAttr("disabled");
        $treeDiv.find("button.setPathOneButton")
            .on("click", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield setPathAsync($tree, path1);
        }))
            .removeAttr("disabled");
        $treeDiv.find("button.setPathTwoButton")
            .on("click", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield setPathAsync($tree, path2);
        }))
            .removeAttr("disabled");
        $treeDiv.find("button.setPathThreeButton")
            .on("click", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield setPathAsync($tree, path3);
        }))
            .removeAttr("disabled");
        $treeDiv.find("button.setPathFourButton")
            .on("click", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield setPathAsync($tree, path4);
        }))
            .removeAttr("disabled");
        $treeDiv.find("button.getPathButton")
            .on("click", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            Notify("Selected path:" + $tree.synTree("getPath"));
        }))
            .removeAttr("disabled");
        $treeDiv.find("button.refreshFullButton")
            .on("click", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield $tree.synTree("refreshAsync", true);
            Notify("Refresh completed");
        }))
            .removeAttr("disabled");
        $treeDiv.find("button.refreshSelectedNodeButton")
            .on("click", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield $tree.synTree("refreshAsync", false);
            Notify("Refresh completed");
        }))
            .removeAttr("disabled");
        $treeDiv.find("button.getSelectedIdButton")
            .on("click", () => {
            Notify("Selected Id: " + $tree.synTree("getSelectedId"));
        })
            .removeAttr("disabled");
        $treeDiv.find("button.getSelectedParentIdButton")
            .on("click", () => {
            Notify("Selected parent Id: " + $tree.synTree("getSelectedParentId"));
        })
            .removeAttr("disabled");
        $treeDiv.find("button.deselectButton")
            .on("click", () => {
            $tree.synTree("unselect");
            Notify("Deselected");
        })
            .removeAttr("disabled");
    });
}
exports.renderTest = renderTest;
